import { lazy } from 'react'
import { Navigate, Outlet, Route, Routes } from 'react-router-dom'

const ProductDashboard = lazy(
  () => import('@/features/produtos/[produtoId]/page'),
)
const ProductCreate = lazy(() => import('@/features/produtos/novo/page'))
const ProductEdit = lazy(
  () => import('@/features/produtos/[produtoId]/editar/page'),
)
const ProductList = lazy(() => import('@/features/produtos/page'))

export function ProductInternalRoutes() {
  return (
    <Routes>
      <Route index element={<ProductList />} />
      <Route path="novo" element={<ProductCreate />} />
      <Route path=":product_id" element={<Outlet />}>
        <Route index element={<ProductDashboard />} />
        <Route path="editar" element={<ProductEdit />} />
        <Route path="*" element={<Navigate to="" />} />
      </Route>
    </Routes>
  )
}
